import { AvailableRoom } from '../types';
import { DiscountLine, sumDiscounts } from './sumDiscounts.helper';

export const getTotalPricesForRooms = (
  allAvailability: (AvailableRoom & { count: number })[][]
) => {
  const roomPriceMap = new Map();
  const discountLines = new Map<string, DiscountLine[]>();
  allAvailability.forEach((rooms) =>
    rooms.forEach(({ count, ...room }) => {
      discountLines.set(room.id, [
        ...(discountLines.get(room.id) ?? []),
        { discount: room.discount, price: room.price_per_stay, count },
      ]);

      const currentTotals = roomPriceMap.get(room.id) || {
        price_per_night: {
          ...room.price_per_night,
          amount: 0,
        },
        price_per_stay: {
          ...room.price_per_stay,
          amount: 0,
        },
      };

      roomPriceMap.set(room.id, {
        price_per_night: {
          ...room.price_per_night,
          amount:
            currentTotals.price_per_night.amount + (room.price_per_night?.amount || 0) * count,
        },
        price_per_stay: {
          ...room.price_per_stay,
          amount: currentTotals.price_per_stay.amount + (room.price_per_stay?.amount || 0) * count,
        },
      });
    })
  );
  roomPriceMap.forEach((totals, roomId) =>
    roomPriceMap.set(roomId, { ...totals, discount: sumDiscounts(discountLines.get(roomId) ?? []) })
  );
  return roomPriceMap;
};
